var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M14.67 8.98l-5.69 4.53L3.33 18V0l5.65 4.49z"}})}
var staticRenderFns = []

export { render, staticRenderFns }